import React, { useState } from 'react';
import { Button } from 'ui';
import { useCurrentUser } from '../../hooks/users/queries';
import UserDisplaySectionContainer from './UserDisplaySectionContainer';
import MfaModal from './MfaModal';

const SecurityComponent = () => {
  const [showMfaModal, setShowMfaModal] = useState(false);
  const { data: currentUser } = useCurrentUser();
  const mfaEnabled = currentUser?.mfa_enabled;

  return (
    <UserDisplaySectionContainer header="Security">
      <MfaModal
        show={showMfaModal}
        onHide={() => setShowMfaModal(false)}
        mfaEnabled={mfaEnabled}
      />
      <div style={{ marginBottom: '10px' }}>
        {mfaEnabled
          ? 'Your account is protected with two factor authentication.'
          : 'You have not enabled two factor authentication yet.'}
      </div>
      <Button variant='blue' onClick={() => setShowMfaModal(true)}>
        {mfaEnabled ? 'Turn Off Two Factor Authentication' : 'Turn On Two Factor Authentication'}
      </Button>
    </UserDisplaySectionContainer>
  );
};

export default SecurityComponent;
